/*
 * @Author: wq
 * @Date: 2020-07-17 17:17:25
 */

import axios from "axios";
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {promise}
 */
export function fetch(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      }, config)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {promise}
 */
export function post(url, data = {}, config = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, config).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/assets/api/request.js